import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { CompanyWizardDispatcher } from "./Variable";
import { FirmInstructionHistoryCollectionModel } from "../../../../../Wrap/Models/Models/Company/FirmInstructionHistoryCollectionModel";

export interface CompanyWizardStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: FirmInstructionHistoryCollectionModel;
}

export class CompanyWizardStoreStatic extends BaseStore<CompanyWizardStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(CompanyWizardDispatcher, (actionData) =>
            this.onCompanyWizardStoreResponse(actionData)
        );
    }

    public getLastResult(): CompanyWizardStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): CompanyWizardStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onCompanyWizardStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
